import { Link } from "react-router-dom";

import { BRAND } from "@/lib/site";

/**
 * Text-first wordmark. The circle-to-square motif echoes the "conduit"
 * metaphor: an input flowing into a structured output.
 */
export function Logo({ className }: { className?: string }) {
  return (
    <Link
      to="/"
      className={className}
      aria-label={`${BRAND} — home`}
    >
      <span className="inline-flex items-center gap-2">
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          aria-hidden="true"
          className="text-primary"
        >
          <circle cx="8" cy="14" r="5" fill="currentColor" />
          <rect x="15" y="9" width="10" height="10" rx="2" fill="#2B63F0" />
        </svg>
        <span className="text-lg font-semibold tracking-tight text-ink">{BRAND}</span>
      </span>
    </Link>
  );
}
